
import React, {useState} from "react"; 
import { Loading, ActionBar, BoxArea } from "../component/BaseComponent";
import MenuComp, { PageTitle, IconList } from "../component/menucomp";
import Pagination from "../component/Paginator";
import { FaExpand } from "react-icons/fa";
import { HttpsRequest, GetAuth, Alerts, Session} from '../component/Utils';
import { APIRoute, RespStatus } from "../component/texts";
import { FormGroup } from '../component/form';
 
import {Accordion, Modal, Button } from 'react-bootstrap'; 
import { ReactSearchAutocomplete } from 'react-search-autocomplete'; 

// import {BASE} from '../component/http';



type PackageType = {    
    isbusy: boolean;    
    body: Record<string, string|number>[];
    pager: PagerType;
    
    edit_mode: boolean;
    form: Record<string, any>[];
    data: Record<string, number | string | unknown>;    
    new_package:Record<string, any>[];
    formaction: 1|2|undefined;

    package_form: Record<string, any>[];
    customer_form: Record<string, any>[];
    address_form: Record<string, any>[];
    form_element_safe: Record<string, any>;

    search_busy: boolean;
    search_field: string;
    customer_search_result: Record<string, any>[];
    launch_modal: boolean;

    waybill_id: undefined| number;
    waybill_data: string;
    waybill_package_id: string;
}

type SearchProps = {

    search_func: (value:string, results?:Record<string, any>[])=> void;
    search_result: Record<string, any>[];
    search_result_format: (item:Record<string, any>)=> void ;
    select_search_result: (item:Record<string, any>)=> void ;
    placeholder: string;
    label: string;
    name: string;
    set_search: (val:string) => void
    defaultvalue?: string;

}
 

const AutoSearchComp = ({placeholder, defaultvalue, search_func, set_search, name, label, search_result, search_result_format, select_search_result}:SearchProps) => {

    const [onfocus, setFocus] = useState(false);

    return (
        <div className={onfocus ? "mb-4 mt-4 posrel z1000" : 'mb-4 mt-4'}>
            <label htmlFor="dispatch_loc"> {label} </label>

            <ReactSearchAutocomplete

                onSearch={search_func}
                onFocus={()=>{setFocus(!onfocus); set_search(name) } }
                placeholder={placeholder} 
                inputSearchString={defaultvalue}
                items={search_result} 
                formatResult={search_result_format}
                onSelect={select_search_result}
 
            />

        </div>

    )
}

type WaybillViewType = {

    show: boolean;
    onHide: ()=> void;
    edit_waybill: ()=> void;
    body: string;
    download_func:()=>void;

}

function DisplayWayBillInfo(props: WaybillViewType) {

     

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      style={{zIndex: 6000}}
      backdrop={'static'}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"> 
          <p> Wabill Information </p> 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
            <div dangerouslySetInnerHTML={{__html: props.body}}></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='info' onClick={props.download_func} size={'sm'} > Download  </Button>
        
        <Button variant='light' onClick={props.edit_waybill} size={'sm'} > Edit  </Button>

        <Button variant={'default'}  onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}


export default class PackageUI extends React.Component<IProps, PackageType> {

    constructor(props: IProps){

        super(props); 

        this.state = {
            isbusy: false,  
            pager: {
                next_page: 0,
                page: 1,
                pages: [],
                prev_page: 0,
                total: 0,
                rows: 10
            },
            body: [],
            form: [],
            package_form: [], 
            customer_form: [],             
            address_form: [], 
            form_element_safe: {},
            data: {},
            formaction: undefined ,
            new_package: [],
            edit_mode: false,
            search_busy: false,
            search_field: '',
            customer_search_result: [],
            launch_modal: false,
            waybill_id: undefined,
            waybill_data:'',
            waybill_package_id: ''
        }

    }

    render (){
        
        let sidecls = this.state.edit_mode ? "col-md-6 col-sm-12" : "col-md-9 col-sm-12";
 
        const _status: Record<string, string> = {
            'Pending': 'warning', 'Delivered': 'success', 'Cancelled': 'danger',
            'Rescheduled': 'info', 'Shipped': 'info', 'Enroute': 'warning', 'Others': 'warning'
        }

        return (
            <div>
                <MenuComp />                 
                <br />
                <ActionBar
                    classname={sidecls}
                    placeholder={"search"}
                    search={false}
                    btntitle={"Create Waybill"}
                    btnfunc={(e) => { e.preventDefault(); this.initiate_new_form()}}
                    btnicon={IconList['package_add'] as JSX.Element}
                />
                <br />
                
 
                <div className="container-fluid">
                    <div className="row posrel">

                        <BoxArea classname={sidecls + ' posrel'} >

                            <PageTitle title={'Waybill List'} />

                            <div className="table-responsive posrel">
                                <table className="table table-condensed table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <td width='15%'> Date </td>
                                            <td width='40%'> Item Name  </td>
                                            <td> Sender </td>
                                            <td> Receiver </td> 
                                            <td> State </td>
                                            <td colSpan={2}> Status </td> 
                                        </tr>
                                    </thead>
                                    <tbody> 
                                        {
                                            this.state.body.length === 0 ? <tr> <td colSpan={7} className="center"> <i> no data found...</i></td> </tr> : (
                                                this.state.body.map((item, idx) => (
                                                    <tr key={`rw${idx}`}>
                                                        <td> {item.date} </td>
                                                        <td> <b> 
                                                            <a href={'#'} 
                                                                onClick={(event)=>{
                                                                    event.preventDefault(); 
                                                                    this.fetch_waybill_info(item.id as number, item.unique_id as string)
                                                                }}> {item.item_name} </a> </b> </td>
                                                        <td> {item.sender } </td>
                                                        <td> {item.receiver} </td>
                                                        <td> {item.state } </td>
                                                        <td> 

                                                            <span className={`text-white badge bg-${_status[item.status]}`}> { item.status } </span>  

                                                        </td>                                                        
                                                        <td className='right'>  
                                                            <button title='Click to expand' 
                                                                className="btn btn-light btn-sm" 
                                                                onClick={()=>this.fetch_waybill_info(item.id as number, item.unique_id as string)}>
                                                                <FaExpand size={15}/>
                                                            </button>                                                        
                                                        </td>  
                                                    </tr>
                                                ))
                                            )
                                        }
                                    </tbody>
                                </table>

                                <Pagination {...this.state.pager} navigate={this.refresh_page} />
                            </div>
                            <div>
                                {this.state.isbusy && <Loading />}
                            </div>

                            <DisplayWayBillInfo 
                                show={this.state.launch_modal}
                                body={this.state.waybill_data}
                                edit_waybill={()=>{ this.hide_modal();this.get_package_form(this.state.waybill_id as number)}}
                                onHide={this.hide_modal} 
                                download_func={()=>this.download_waybill_info(this.state.waybill_package_id)}

                            />

                        </BoxArea>

                        {
                            this.state.edit_mode ? (
                                <BoxArea classname={'col-md-6'} >
                                    <PageTitle title={ this.state.formaction === 1? 'New Waybill': 'Edit Waybill'} />
                             
                                    <form method='post' autoComplete="off" onSubmit={this.save_waybill_data}>
                                         
                                        <Accordion defaultActiveKey="0">
                                          <Accordion.Item eventKey="0">
                                            <Accordion.Header>Customer Information </Accordion.Header>
                                            <Accordion.Body>
                                               <div>  
                                                     {
                                                        this.state.customer_form.map((fld, idx) => {

                                                            if (fld.name === 'rec_name' || fld.name == 'cus_name'){

                                                                return <AutoSearchComp                                                                    
                                                                    key={`autosearch_${fld.name}_${idx}`}
                                                                    placeholder={fld.placeholder}
                                                                    name={fld.name}
                                                                    label={fld.label}
                                                                    set_search={(name:string)=>this.setState({search_field: name}) }
                                                                    search_func={this.trigger_search}
                                                                    search_result={this.state.customer_search_result}
                                                                    defaultvalue={fld.defaultvalue|| ''}
                                                                    search_result_format={this.format_result}
                                                                    select_search_result={this.handle_select}
                                                                />
                                                            }

                                                            return <FormGroup
                                                                key={`cus-${idx}`}
                                                                obj={fld} onchange={
                                                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                                                    this.onchange(e);
                                                                }}
                                                                onselectchange={this.onchange}
                                                                textarea_change={(e: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>)=> this.onchange(e as any)}
                                                            />;
                                                        })
                                                    }
                                                </div>

                                            </Accordion.Body>
                                          </Accordion.Item>
                                          <Accordion.Item eventKey="1">
                                            <Accordion.Header> Package Address </Accordion.Header>
                                            <Accordion.Body>
                                               <div>                                            
                                                    {
                                                        this.state.address_form.map((fld, idx) => {
                                                            return <FormGroup
                                                                key={`address-${idx}`}
                                                                obj={fld} onchange={
                                                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                                                    this.onchange(e);
                                                                }}
                                                                onselectchange={this.onchange}
                                                                textarea_change={(e: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>)=> this.onchange(e as any)}
                                                            />;
                                                        })
                                                    }

                                                </div>
                                            </Accordion.Body>
                                          </Accordion.Item>

                                          <Accordion.Item eventKey="2">
                                            <Accordion.Header style={{'background': '#eee'}}> Package Information </Accordion.Header>
                                            <Accordion.Body>
                                                <div>
                                                {
                                                    this.state.package_form.map((fld, idx) => {
                                                        return <FormGroup
                                                            key={`device-${idx}`}
                                                            obj={fld} onchange={
                                                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                                                this.onchange(e);
                                                            }}
                                                            onselectchange={this.onchange}
                                                            textarea_change={(e: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>)=> this.onchange(e as any)}
                                                        />;
                                                    })
                                                }

                                                </div>
                                            </Accordion.Body>   
                                          </Accordion.Item>
                                        </Accordion>

                                        <hr />

                                        <div className="mb-4 mt-4">
                                            <div className="form-group row">
                                                <div className="row">
                                                    <div className="d-grid gap-2 col-md-6 col-sm-12 mb-3">
                                                        <button type="button" onClick={this.save_waybill_data} className="btn btn-primary btn-lg">
                                                            Save Changes
                                                        </button>
                                                    </div>
                                                    <div className="d-grid gap-2 col-md-6 col-sm-12 mb-3">
                                                        <button type="button" onClick={() => this.setState({ edit_mode: false })} className="btn btn-light btn-lg">
                                                            &nbsp;&nbsp; Close &nbsp;&nbsp;
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                    
                                    <style> 
                                    {`
                                        
                                        .accordion-button {
                                            font-size: 18px;
                                            font-weight: 600;
                                            background-color: #eee;
                                        }
                                        
                                        .accordion-button:not(.collapsed) {
                                            color: var(--bs-accordion-active-color);
                                            background-color: #ccc;
                                            box-shadow: inset 0 calc(-1* var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
                                        }

                                        .z1000{ z-index: 1000; }
                                        .wrapper:first-child {
                                            border-radius: 5px;
                                        }

                                    `}
                                    </style>
                                    <div>
                                        {this.state.isbusy && <Loading />}
                                    </div>

                                </BoxArea>


                            ) : null
                        }
                        
                    </div>

                </div>
            </div>
        )
    }

    componentDidMount(): void {
        this.load_package_data();
    }

    onchange = (event: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
 
        const {data} = this.state; 

        data[event.target.name] = event.target.value;
        
        console.log(event.target.name);

        this.setState({
            data
        })

    }

    refresh_page = (page: number, rows: string|undefined) => {       
        this.load_package_data({page: String(page), rows:rows || '10'}); 
    }

    save_waybill_data = (event: React.FormEvent<HTMLFormElement|HTMLButtonElement>) => {

        event.preventDefault();
 
        const data = {...this.state.data}; 

        const post_callback = (resp:RespArgs) => {

            if (resp.status === RespStatus.success){

                this.setState({
                    isbusy: false,
                    formaction: undefined,
                    edit_mode: false,
                    customer_search_result: [],
                    data:{}
                }, ()=>this.refresh_page(1, '10') )

            } else {

                // failed posting 

                this.setState({
                    package_form: [...resp.body.form],
                    address_form: [...resp.body.address_form],
                    customer_form: [...resp.body.customer_form],
                    isbusy: false,

                }, ()=> Alerts.show_error('A validation error occured. please check the fields'))
            }
        }

        let url: string =  APIRoute.waybill_data_add

        if (this.state.formaction === 2){
            url = APIRoute.waybill_data_edit + data.id 
        }

        HttpsRequest.post(
            url,
            data,
            post_callback,
            GetAuth(),
            (resp:RespArgs) => this.setState({isbusy: false}, ()=>Alerts.show_error(resp.status_msg))
        )
    }

    load_package_data = (args?: Record<string, string>) => {
        HttpsRequest.get(
            APIRoute.waybill_data, 
            this.get_callback,  GetAuth(), 
            (args || {}), (r:RespArgs) => this.setState({isbusy: false})
        )
    }

    get_callback = (resp: RespArgs) => {
        
        if (resp.status === RespStatus.success){
            this.setState({
                body: resp.body.data, 
                isbusy: false, 
                
                edit_mode: false,
                pager: resp.body.pager,
                form: [], // reset form every upload

                package_form: [...resp.body.form],
                address_form: [...resp.body.address_form],
                customer_form: [...resp.body.customer_form],

                form_element_safe: {
                    package_form: [...resp.body.form],
                    address_form: [...resp.body.address_form],
                    customer_form: [...resp.body.customer_form]
                }
            })  

        } else {
            this.setState({                
                isbusy: false 
            })
            
            Alerts.show_error(resp.status_msg); 

        }
 
    }

    initiate_new_form = () => {

        const nform = [...this.state.new_package];
        this.setState({
            package_form: [...this.state.form_element_safe.package_form],
            address_form: [...this.state.form_element_safe.address_form],
            customer_form: [...this.state.form_element_safe.customer_form],
            edit_mode: true, formaction: 1
        }); 
        
    }

    get_package_form = (pid:number) => {

        const get_callback = (resp: RespArgs) => {
            
            if (resp.status === RespStatus.success){
                this.setState({
                    data: resp.body.initial_data,
                    isbusy: false, 
                    edit_mode: true,                    
                    package_form: resp.body.form, 
                    customer_form: resp.body.customer_form,
                    address_form: resp.body.address_form,
                    formaction: 2
                })  
    
            } else {
                this.setState({
                    isbusy: false 
                })
                
                Alerts.show_error(resp.status_msg); 
    
            }
        }

        HttpsRequest.get(
            APIRoute.waybill_data_edit + pid, 
            get_callback,  GetAuth(), 
            {}, 
            (r:RespArgs) => this.setState({isbusy: false})
        )

        this.setState({isbusy: true, form: [], data:{},  edit_mode: false})

    } 


    get_form_default = (form: Record<string, any>[], fieldname:string) =>  {
        return form.filter(item => item.name == fieldname)        
    }

    set_form_default = (form: Record<string, string|number>[], fieldname:string, value:string) => {
         
        const field = form.find(item => item.name == fieldname)
        
        if (field !== undefined){            
            field.defaultvalue = value; 
        }
    }

    format_result = (item:Record<string, any>) => {
        return (
            <span>Name: {item.text}; Phone : {item.phone} </span>
        )
    }

    handle_select = (item:Record<string, any>) => {
                
        const customer_form = [...this.state.customer_form]
        const data = {...this.state.data}
 
        if (this.state.search_field == 'rec_name'){

            this.set_form_default(customer_form, 'rec_name', item.name)
            this.set_form_default(customer_form, 'rec_phone', item.phone)
            this.set_form_default(customer_form, 'rec_email', item.email)
            this.set_form_default(customer_form, 'rec_id', item.id)

            data['rec_name'] = item.name 
            data['rec_phone'] = item.phone 
            data['rec_email'] = item.email 
            data['rec_id'] = item.id 

        } else if (this.state.search_field === 'cus_name'){

            this.set_form_default(customer_form, 'cus_name', item.name)
            this.set_form_default(customer_form, 'cus_phone', item.phone)
            this.set_form_default(customer_form, 'cus_email', item.email)
            this.set_form_default(customer_form, 'cus_id', item.id)

            data['cus_name'] = item.name ;
            data['cus_phone'] = item.phone ;
            data['cus_email'] = item.email ;
            data['cus_id'] = item.id ;

        }

        this.setState({customer_form, data}, ()=> console.log(this.state.data));
        
    }

    trigger_search = (inputval:string, results?:Record<string, any>[]) => {
        
        if (inputval.length >= 3){
            this.customer_search(inputval);
        }

        const data = {...this.state.data}
        if (this.state.search_field === 'rec_name' && data.rec_id !== undefined ){
            data.rec_id = null 
        } else if (this.state.search_field === 'cus_name' && data.cus_id !== undefined ){
            data.cus_id = null
        }


        data[this.state.search_field] = inputval ; 
        this.setState({data});

    }
    
    customer_search = (value:string) => {

        const customer_search_callback = (resp: RespArgs) => {
            
            if (resp.status == RespStatus.success){

                this.setState({ 
                    search_busy: false, 
                    customer_search_result: resp.body.results                    
                }, ()=> console.log('result after update', this.state.customer_search_result));

            } else {
                this.setState({
                    search_busy: false 
                })
                
                Alerts.show_error(resp.status_msg); 

            }

        }

        HttpsRequest.get(
            APIRoute.customers_search, 
            customer_search_callback,  
            GetAuth(), 
            {q: value}, 
            (r:RespArgs) => this.setState({search_busy: false})
        )

        this.setState({search_busy: true})
    
    }

    hide_modal =  ()=>this.setState({launch_modal: !this.state.launch_modal})

    
    fetch_waybill_info = (waybill_id:number, unique_id:string) => {

        
        const handle_callback = (resp:RespArgs) => {

            if (resp.status === RespStatus.success){
                this.setState({ 
                    isbusy: false, 
                    launch_modal: true,
                    waybill_data: resp.body.content                                         
                 })  
    
            } else {
                this.setState({
                    isbusy: false 
                })
                
                Alerts.show_error(resp.status_msg);    
            }

        }

        HttpsRequest.get(
            APIRoute.waybill_data_view + unique_id, 
            handle_callback,  GetAuth(), 
            {}, 
            (r:RespArgs) => this.setState({isbusy: false})
        )

        this.setState({
            isbusy: true, launch_modal:false, 
            edit_mode:false, waybill_package_id: unique_id,
            waybill_id: waybill_id as number})

    }

    download_waybill_info = (waybill:string) => {

        
        const handle_callback = (resp:RespArgs) => {

            if (resp.status === RespStatus.success){
                this.setState({ 
                    isbusy: false, 
                    launch_modal: true,
                    waybill_data: resp.body.content                                         
                 })  
    
            } else {
                this.setState({
                    isbusy: false 
                })
                
                Alerts.show_error(resp.status_msg);    
            }

        }

        let anchor = document.createElement('a'); 
        
        anchor.setAttribute('href', process.env.REACT_APP_BASE+APIRoute.waybill_data_download+waybill+'?JWT='+Session.get('token'));
        anchor.setAttribute('target', '_blank');
        
        anchor.click(); 
        // this.setState({isbusy: true, launch_modal:false, edit_mode:false, waybill_id: waybill as number})

    }

}   

